<ng-container [ngSwitch]="type">
  <mat-form-field appearance="outline" *ngSwitchCase="'number'">
    <input type="number" matInput [formControlName]="controlName"/>
    <small matSuffix>{{ suffix }}</small>
  </mat-form-field>
  <mat-form-field appearance="outline" *ngSwitchCase="'time'">
    <input uzTimeInput matInput [formControlName]="controlName"/>
    <small matSuffix>{{ suffix }}</small>
  </mat-form-field>
  <mat-form-field appearance="outline" *ngSwitchDefault>
    <input matInput [formControlName]="controlName"/>
    <small matSuffix>{{ suffix }}</small>
  </mat-form-field>
</ng-container>
